import gql from 'graphql-tag';

export const deleteCommercialFacilityNote = gql`
  mutation deleteCommercialFacilityNote($id: ID!) {
    deleteCommercialFacilityNote(id: $id) {
      value
    }
  }
`;
